import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import _ from 'lodash';
import PointsField from './PointsField';

const Points = ({ field, applications, max, sum, groupByDistricts, districts }) => (
  <Field
    name={field}
    component={PointsField}
    values={applications}
    sum={sum}
    max={max}
    groupByDistricts={groupByDistricts}
    districts={districts}
  />
);

Points.propTypes = {
  field: PropTypes.string.isRequired,
  applications: PropTypes.array.isRequired,
  max: PropTypes.number.isRequired,
  sum: PropTypes.number.isRequired,
  groupByDistricts: PropTypes.bool.isRequired,
  districts: PropTypes.array,
};

function mapStateToProps(state) {
  let sum = 0;
  if (state.form.budgetVoteForm.values && state.form.budgetVoteForm.values.votes) {
    state.form.budgetVoteForm.values.votes.forEach(c => sum += (parseFloat(c.value) || 0));
  }
  return {
    sum: _.round(sum, 2),
  };
}

export default connect(mapStateToProps)(Points);



// WEBPACK FOOTER //
// ./src/components/budget/types/Points.js